import { RouteConfig } from 'vue-router';
import OtherOperationsComponent from './other-operations.vue';
// import UserLoginLogoutActivityLogs from './activity-logs/user-login-logout.component.vue';

export const OtherOperationsRoute: RouteConfig = {// tslint:disable-line:variable-name
  path: 'other-operations',
  component: OtherOperationsComponent,
  // redirect: 'activitylogs/loginlogout',
  // children: [
  //   {
  //     name: 'activitylogs.loginlogout',
  //     path: 'loginlogout',
  //     component: UserLoginLogoutActivityLogs,
  //   },
  // ],
};

export function getDefaultParams() {
  return {};
}
